import { useState, useEffect } from "react"
import { useReactiveVar } from "@apollo/client"
import Toast from "react-bootstrap/Toast"
import ToastContainer from "react-bootstrap/ToastContainer"
import classNames from "classnames"
import isEmpty from "lodash/isEmpty"
import uniq from "lodash/uniq"
import { successesVar } from "cache"
import { successMessages } from "./constants"
import styles from "./SuccessToast.module.scss"

const SuccessToast = () => {
  const [isShowing, setIsShowing] = useState(false)
  const successes = useReactiveVar(successesVar)

  useEffect(() => {
    if (!isEmpty(successes)) {
      setIsShowing(true)
    }
  }, [successes])

  useEffect(() => {
    return () => {
      successesVar(null)
    }
  }, [])

  if (isEmpty(successes)) return null

  const handleClose = () => {
    setIsShowing(false)
    successesVar(null)
  }

  const uniqueSuccesses = uniq(successes)

  return (
    <ToastContainer
      className={classNames(
        "p-3 w-100 d-flex justify-content-center",
        styles.toastContainer
      )}
      position="bottom-center"
    >
      <div className="col-sm-9 col-md-6">
        {uniqueSuccesses.map((success) => {
          return (
            <Toast
              onClose={handleClose}
              className={styles.toast}
              show={isShowing}
              bg="success"
              delay="3000"
              autohide
              key={success}
            >
              <Toast.Header className={classNames(styles.body, "p-3")}>
                <div className="me-auto">{successMessages[successes]}</div>
              </Toast.Header>
            </Toast>
          )
        })}
      </div>
    </ToastContainer>
  )
}

export default SuccessToast
